import React, { useState } from 'react';
import { userService } from '../../services/userService';

// 로그인한 본인이 직접 비밀번호를 바꾸는 공용 모달 (PC/모바일 공용)
const ChangePasswordModal = ({ onClose }) => {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 입력 유효성 검사
    if (next.length < 6) return alert('새 비밀번호는 6자 이상이어야 합니다.');
    if (next !== confirm) return alert('새 비밀번호가 서로 일치하지 않습니다.');
    if (next === current) return alert('새 비밀번호가 현재 비밀번호와 같습니다. 다른 비밀번호를 입력하세요.');

    setLoading(true);
    const result = await userService.changePassword(current, next);
    setLoading(false);

    if (result.success) {
      alert('✅ 비밀번호가 변경되었습니다. 다음 로그인부터 새 비밀번호를 사용하세요.');
      onClose();
    } else {
      alert(result.message || '비밀번호 변경에 실패했습니다.');
    }
  };

  const styles = {
    overlay: {
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.5)', display: 'flex',
      justifyContent: 'center', alignItems: 'center', zIndex: 9999, padding: '16px',
    },
    card: {
      width: '100%', maxWidth: '360px', background: '#ffffff',
      borderRadius: '16px', padding: '28px 24px', boxSizing: 'border-box',
      boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
    },
    title: { margin: '0 0 6px 0', fontSize: '18px', fontWeight: '800', color: '#1e293b' },
    desc: { margin: '0 0 20px 0', fontSize: '12px', color: '#94a3b8' },
    input: {
      width: '100%', padding: '13px', marginBottom: '10px', borderRadius: '10px',
      border: '1px solid #e2e8f0', boxSizing: 'border-box', outline: 'none', fontSize: '14px',
    },
    btnRow: { display: 'flex', gap: '8px', marginTop: '12px' },
    cancelBtn: {
      flex: 1, padding: '13px', background: '#f1f5f9', color: '#64748b',
      border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px',
    },
    saveBtn: (disabled) => ({
      flex: 1, padding: '13px', background: disabled ? '#94a3b8' : '#11caa0', color: '#ffffff',
      border: 'none', borderRadius: '10px', cursor: disabled ? 'default' : 'pointer', fontWeight: 'bold', fontSize: '14px',
    }),
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.card} onClick={(e) => e.stopPropagation()}>
        <h3 style={styles.title}>🔑 비밀번호 변경</h3>
        <p style={styles.desc}>본인 확인을 위해 현재 비밀번호를 먼저 입력해주세요.</p>
        <form onSubmit={handleSubmit}>
          <input
            style={styles.input}
            type="password"
            placeholder="현재 비밀번호"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            required
            autoFocus
          />
          <input
            style={styles.input}
            type="password"
            placeholder="새 비밀번호 (6자 이상)"
            value={next}
            onChange={(e) => setNext(e.target.value)}
            required
            minLength={6}
          />
          <input
            style={styles.input}
            type="password"
            placeholder="새 비밀번호 확인"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
          />
          <div style={styles.btnRow}>
            <button type="button" onClick={onClose} style={styles.cancelBtn}>취소</button>
            <button type="submit" disabled={loading} style={styles.saveBtn(loading)}>
              {loading ? '변경 중...' : '변경하기'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
